module.exports = __webpack_public_path__ + "fonts/Mukta-600-devanagari13.b8f6bc7.woff2";